import { MessageStyle } from '../../../graphql/schema';

export type BannerStyle = Exclude<MessageStyle, 'ADVICE'>;
export type BannerVariant = 'success' | 'info' | 'warning' | 'critical';
export const messageBannerVariant: Record<BannerStyle, BannerVariant> = {
  ERROR: 'critical',
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
};
